export default __webpack_public_path__ + "static/media/step-bg1.4be43d1d.png";